module.exports = __webpack_public_path__ + "media/images/Icon-bed-59eceed33c45c6160f6bb65080067645.svg";